import script from "./Chara.vue?vue&type=script&setup=true&lang=js"
export * from "./Chara.vue?vue&type=script&setup=true&lang=js"

import "./Chara.vue?vue&type=style&index=0&id=ebb6ed22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ebb6ed22"]])

export default __exports__